import { React } from 'react';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';
import { addMinutes } from 'date-fns';
import { filterBulkLabels } from 'store/thunks/workQueueThunks';
import DateRangePickerFieldWithLimit from 'common/forms/DateRangePickerFieldWithLimit';

const BulkLabelsOuterFilter = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue: { bulkLabels } }) => bulkLabels.filter);

  const dateToDateString = (dateInput) => {
    if (!dateInput) return undefined;
    if (typeof dateInput === 'string') {
      return dateInput.split('T')[0];
    }
    if (dateInput instanceof Date) {
      const year = dateInput.getFullYear();
      const month = String(dateInput.getMonth() + 1).padStart(2, '0');
      const day = String(dateInput.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    return undefined;
  };

  const onHandleDateChange = (dateRange) => {
    const createdAtLength = dateRange.length;
    const createdAt = createdAtLength === 1 ? dateRange[0] : undefined;
    const createdBetween = !createdAt
      ? dateRange?.map((date) => dateToDateString(date))
      : undefined;

    dispatch(
      filterBulkLabels({
        filter: {
          ...filter,
          createdAt: dateToDateString(createdAt),
          createdBetween,
        },
      })
    );
  };

  return (
    <Grid container alignItems='center'>
      <Grid item sx={{ mr: 2 }}>
        <DateRangePickerFieldWithLimit
          label='Date Range'
          onDateChange={onHandleDateChange}
          initialValue={filter?.createdAt ? [filter.createdAt] : filter?.createdBetween}
          maxMonths={3}
          maxDate={addMinutes(new Date(), 60)}
        />
      </Grid>
    </Grid>
  );
};

export default BulkLabelsOuterFilter;
